module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('customer.addGroup')
    },
    model: {
      value: (_vm.groupDialogVisible),
      callback: function($$v) {
        _vm.groupDialogVisible = $$v
      },
      expression: "groupDialogVisible"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('group.name'),
      "rules": [{
        required: true,
        message: 'Please input group name',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.groupDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.create')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.deleteConfirm'),
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('group.deleteConfirmText')) + " " + _vm._s(_vm.selectedGroup.name))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.deleteSelectedGroup()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.confirm')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.edit')
    },
    model: {
      value: (_vm.editDialog),
      callback: function($$v) {
        _vm.editDialog = $$v
      },
      expression: "editDialog"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('group.name'),
      "rules": [{
        required: true,
        message: 'Please input group name',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmitEdit(_vm.form)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.edit')))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.groupDialogVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('customer.addGroup')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "120%"
    },
    attrs: {
      "data": _vm.groups,
      "border": "border"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('group.name'),
      "prop": "name"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), (scope.row.isDressOwner) ? _c('el-tag', {
          attrs: {
            "type": 'success',
            "close-transition": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('group.dressOwner')))]) : _vm._e()]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-dropdown', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "trigger": "click",
            "size": "small"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('i', {
          staticClass: "el-icon-more"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.showEditDialog(_vm.groups[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.edit')))]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.confirmDelete(_vm.groups[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.delete')))])], 1)], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "10px 0px",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5f6e43"}!./src/pages/customer/group/index.html
// module id = 798
// module chunks = 1